import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FaFileAlt, FaDownload, FaEye } from "react-icons/fa";
import { axios } from "../../../HelperFunctions/axios";
import DashboardLayout from "./layout/DashboardLayout";
import actionCreater from "../../../redux/actions/actionCreater";
import { connect } from "react-redux";
import "../Dashboard/layout/styles.css";
import { Spinner } from "react-bootstrap";
import moment from "moment";

class Paystub extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this.handleGetPaystubs();
  }

  handleGetPaystubs = async () => {
    let url = process.env.REACT_APP_BACKEND_URL_LOCAL;
    if (process.env.REACT_APP_MODE === "live") {
      url = process.env.REACT_APP_FRONTEND_URL_LIVE;
    }
    const token = localStorage.getItem("tokens");
    try {
      const response = await axios.get(`${url}api/auth/get-paystubs`, {
        headers: { Authorization: `bearer ${token}` },
      });
      this.props.getPaystubData(response.data);
    } catch (e) {
      console.log(e);
    }
    this.setState({ loading: false });
  };

  render() {
    const { paystubData } = this.props;
    const stubs = paystubData ?? [];

    return (
      <DashboardLayout>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
          <div>
            <h1 className="dash-page-title">My Paystubs</h1>
            <p className="dash-page-subtitle">
              {stubs.length} paystub{stubs.length !== 1 ? "s" : ""} generated
            </p>
          </div>
          <Link to="/paystubs" className="btn btn-secondary" style={{ flexShrink: 0 }}>
            + New Paystub
          </Link>
        </div>

        {this.state.loading ? (
          <div style={{ textAlign: "center", padding: 60 }}>
            <Spinner animation="border" variant="primary" />
          </div>
        ) : stubs.length === 0 ? (
          <div className="dash-section-card" style={{ textAlign: "center", padding: "60px 20px" }}>
            <FaFileAlt style={{ fontSize: 48, color: "var(--color-text-tertiary)", marginBottom: 16 }} />
            <h4 style={{ color: "var(--color-text-secondary)", marginBottom: 8 }}>No paystubs yet</h4>
            <p style={{ color: "var(--color-text-tertiary)", marginBottom: 20 }}>
              Create your first paystub to see it here
            </p>
            <Link to="/paystubs" className="btn btn-secondary">
              Create Paystub
            </Link>
          </div>
        ) : (
          <div className="paystub-card-grid">
            {stubs.map((stub, index) => {
              const params = stub.params || {};
              const companyName = params.company_name || "—";
              const employeeName = params.employee_name || "—";
              const createdDate = stub.createdAt
                ? moment(stub.createdAt).format("MMM D, YYYY")
                : "—";
              const payDates = params.pay_dates || [];

              return (
                <div className="paystub-row" key={stub._id || index}>
                  <div className="paystub-row-info">
                    <strong>{companyName}</strong>
                    <span>
                      {employeeName} &middot; {payDates.length} pay period{payDates.length !== 1 ? "s" : ""} &middot; {createdDate}
                    </span>
                  </div>
                  <div className="paystub-row-actions">
                    <Link
                      to={`/dashboard/paystub/${stub._id}`}
                      className="btn btn-outline-primary"
                      title="View Details"
                    >
                      <FaEye style={{ marginRight: 4 }} /> View
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </DashboardLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  paystubData: state?.paystubData,
});

export default connect(mapStateToProps, {
  getPaystubData: actionCreater.getPaystubData,
})(Paystub);
